import type { SVGProps } from "react"

import { useTranslations } from "next-intl"

import { tv, type VariantProps } from "@/lib/utils/tv"

const spinner = tv({
  base: "motion-safe:animate-spin",
  variants: { size: { sm: "size-3", md: "size-4", lg: "size-5" } },
  defaultVariants: { size: "md" },
})

export const Spinner = ({ size, className, ...rest }: VariantProps<typeof spinner> & Omit<SVGProps<SVGSVGElement>, "size">) => {
  const t = useTranslations("common")
  return (
    <svg role="status" aria-label={t("loading")} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={spinner({ size, className })} {...rest}>
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
    </svg>
  )
}
